function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  flex-shrink: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { Flex } from 'rebass';
import { Button, Tooltip } from 'shared/components';
var ButtonContainer = styled(Flex)(_templateObject(), function(props) {
    return props.flexShrink;
});
export default observer(function(_param) {
    var children = _param.children, _param_width = _param.width, width = _param_width === void 0 ? [
        1,
        1,
        1,
        'auto'
    ] : _param_width, _param_mt = _param.mt, mt = _param_mt === void 0 ? [
        20
    ] : _param_mt, _param_mb = _param.mb, mb = _param_mb === void 0 ? [
        0
    ] : _param_mb, _param_loading = _param.loading, loading = _param_loading === void 0 ? false : _param_loading, _param_alignSelf = _param.alignSelf, alignSelf = _param_alignSelf === void 0 ? 'auto' : _param_alignSelf, _param_alignItems = _param.alignItems, alignItems = _param_alignItems === void 0 ? 'center' : _param_alignItems, _param_buttonContainerWidth = _param.buttonContainerWidth, buttonContainerWidth = _param_buttonContainerWidth === void 0 ? '100%' : _param_buttonContainerWidth, _param_inverted = _param.inverted, inverted = _param_inverted === void 0 ? false : _param_inverted, _param_link = _param.link, link = _param_link === void 0 ? false : _param_link, tooltip = _param.tooltip, _param_flexShrink = _param.flexShrink, flexShrink = _param_flexShrink === void 0 ? '0' : _param_flexShrink, props = _object_without_properties(_param, [
        "children",
        "width",
        "mt",
        "mb",
        "loading",
        "alignSelf",
        "alignItems",
        "buttonContainerWidth",
        "inverted",
        "link",
        "tooltip",
        "flexShrink"
    ]);
    return /*#__PURE__*/ _jsxs(ButtonContainer, {
        width: buttonContainerWidth,
        mt: mt,
        mb: mb,
        flexDirection: "column",
        alignItems: alignItems,
        justifyContent: "center",
        alignSelf: alignSelf,
        flexShrink: flexShrink,
        className: "modal-button-container",
        children: [
            !tooltip && /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
                width: width,
                loading: loading,
                inverted: inverted,
                link: link
            }, props), {
                children: children
            })),
            tooltip && /*#__PURE__*/ _jsx(Tooltip, {
                mainCopy: /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
                    width: width,
                    loading: loading,
                    inverted: inverted,
                    link: link
                }, props), {
                    children: children
                })),
                tooltipCopy: tooltip,
                hoverMain: true,
                right: "-29px",
                bottom: "44px"
            })
        ]
    });
});
